export default __webpack_public_path__ + "static/media/SwamijiNew3.f673df62.JPG";